export default __webpack_public_path__ + "static/media/complementary--pass-left--g1.e63e20d4.png";